import {sbkCoreBreakpointLg} from '@/tokens/variables';
import { css, unsafeCSS } from 'lit';

const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const tileStyles = css`
    :host {
        position: relative;
    }

    .tile {
        display: block;
        color: var(--sbkTileColorFgColorOnLightEnabled);
        border-radius: var(--sbkTileBorderRadiusDefault);
        overflow: hidden;
        outline-offset: var(--sbkTileBorderGapFocus);
        border: 1px solid transparent;
        height: 100%;
        background: var(--sbkTileColorBgColorDefault);
        text-decoration: none;
        font: var(--sbkTileTypographySmallScreenPrice);
        @media (min-width: ${breakpointLg}) {
            font: var(--sbkTileTypographyLargeScreenPrice);
        }

        &.tile--clickable {
            cursor: pointer;
        }

        &.tile--variant-summary {
            background: var(--sbkTileColorBgColorSummary);
        }
        

        &.tile--clickable:focus-visible {
            outline: var(--sbkTileBorderFocus);
            border-radius: var(--sbkTileBorderRadiusFocus);
        }

        @media (hover: hover) and (pointer: fine) {
            &.tile--clickable:hover {
                border: var(--sbkTileBorderHover);
            }
        }
    }

    .tile__content {
        display: flex;
        justify-content: space-between;
        gap: var(--sbkTileSpacingSmallScrGapVertical);
        align-items: center;
        padding: var(--sbkTileSpacingSmallScrInsetTop) var(--sbkTileSpacingSmallScrInsetRight) var(--sbkTileSpacingSmallScrInsetBottom) var(--sbkTileSpacingSmallScrInsetLeft);

        @media (min-width: ${breakpointLg}) {
            padding: var(--sbkTileSpacingLargeScrInsetTop) var(--sbkTileSpacingLargeScrInsetRight) var(--sbkTileSpacingLargeScrInsetBottom) var(--sbkTileSpacingLargeScrInsetLeft);
        }
    }
    
    .tile_headline-icon {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: var(--sbkTileSpacingSmallScrGapIconTitle);

        @media (min-width: ${breakpointLg}) {
            gap: var(--sbkTileSpacingLargeScrGapIconTitle);
        }
    }

    .tile_amount-icon {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        gap: var(--sbkTileSpacingSmallScrGapVertical);

        @media (min-width: ${breakpointLg}) {
            flex-direction: row;
            align-items: center;
            gap: var(--sbkTileSpacingLargeScrGapPriceChevron);
        }

        sbk-icon {
            height: 40px;
            align-items: center;

            @media (min-width: ${breakpointLg}) {
                height: initial;
                
            }
        }
    }
    
    .headline {
        margin: 0;
        hyphens: auto;
        font: var(--sbkTileTypographySmallScreenPrice);
        @media (min-width: ${breakpointLg}) {
            font: var(--sbkTileTypographyLargeScreenPrice);
        }
    }

    .amount {
        display: flex;
        gap: var(--sbkTileSpacingSmallScrGapEuroNumber);

        .price {
            font: var(--sbkTileTypographySmallScreenPrice);
            @media (min-width: ${breakpointLg}) {
                font: var(--sbkTileTypographyLargeScreenPrice);
            }
        }
        .euro {
            font: var(--sbkTileTypographySmallScreenEuro);
            @media (min-width: ${breakpointLg}) {
                font: var(--sbkTileTypographyLargeScreenEuro);
            }
        }

        @media (min-width: ${breakpointLg}) {
            gap: var(--sbkTileSpacingLargeScrGapEuroNumber);
        }
    }
    
    .tile--variant-summary .tile_amount-icon {
        padding-right: calc(var(--sbkTileSpacingSmallScrGapVertical) + var(--sbkTileSizingIconSizeChevron));
        @media (min-width: ${breakpointLg}) {
            padding-right: calc(var(--sbkTileSpacingLargeScrGapPriceChevron) + var(--sbkTileSizingIconSizeChevron));
        }
    }
`;
